import style from '../CSS/Result.module.css';
import React from "react";
import playButton from "../img/playButton.png";

const ResultItem = ({userInfo, comment, selectStatus}) => {

    return (
        <>
            <div className={style.result}>
                <div className={style.profile}>
                    <img style={{width: '26%'}} src={userInfo.image} alt="userImage"/>
                    <div>
                        <h6>{userInfo.name}</h6>
                        <p>User like: {userInfo.like}</p>
                        <div>
                            <span><i className="fa-solid fa-heart"></i> {userInfo.love}</span>
                            <span><b>Mark</b> {userInfo.mark}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={style.comment__title}>Oxygen Comment:</p>
                </div>
                <div className={style.comment}>
                    {
                        comment && comment.length > 0 && comment.map((item)=> (
                            <div className={style.comment__item}>
                                <img className={style.comment__item__img__one} src={item.superStarImage} alt=""/>
                                <p>{item.superStarName}</p>
                                <div className={style.comment__item__img__two} style={{
                                    backgroundImage: `url(${item.superStarImage})`
                                }}>
                                    <img src={playButton} alt="playButton"/>
                                </div>
                            </div>
                        ))
                    }
                </div>

                <div style={{textAlign: 'center'}}>
                    <button className={selectStatus ? style.button : style.reject__button}>{ selectStatus ? 'Select' : 'Deselect'}</button>
                </div>
            </div>
        </>
    );
};

export default ResultItem;